import Api from "./Api";
import store from "../state/store";

export default {
  getAttendanceModes(params) {
    console.log("params", params);
    return Api().get(
      `/attendance_mode/${store.getters["authfack/currentEntity"].id}`,
      { params }
    );
  },

  addAttendanceMode(payload) {
    return Api().post(`/attendance_mode`, payload);
  },
  editMode(payload) {
    return Api().put(`/attendance_mode/${payload.id}`, payload.data);
  },
  getAttendanceCodes(payload) {
    return Api().get(`/attendance_code/${store.getters["authfack/currentEntity"].id}/${payload.id}`, {
      params: {
        add_reason: payload.add_reason ? true : false,
        attendance_mode_id: payload.attendance_mode_id
      }
    }
    );
  },
  addReason(payload) {
    return Api().post(`/reason`, payload);
  },
  editReason(payload) {
    return Api().put(`/reason/${payload.reason_id}`, payload.obj);
  },

  deleteModeOrReason(payload) {
    return Api().delete(`/${payload.row}/${payload.id}`);
  },
  getReasonsForSignIn(params) {
    return Api().get("get_reasons_should_check_in_visit", { params });
  },
  checkDuplicateName(params) {
    return Api().get(
      `/attendance-mode/unique`, {params}
    );
  },
  getAttendanceModeById(id){
    return Api().get(`/attendance_modes/${id}`);
  },
  checkSysAdminPermissionOnAttendanceMode(userId, intIds){
    return Api().get(`/check_have_premissions_to_used_attandace_mode_intgration/`,{ params :{
      userId,
      intIds
      }
    })
  }
};
